import { render } from "./LoginPage.vue?vue&type=template&id=218f8946"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=218f8946&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\attendance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__